module.exports = __webpack_public_path__ + "img/2017-03-11.6878b629.jpg";